export const GET_BOOK_CITATION_REQUEST = "get/book/citation/request";
export const GET_BOOK_CITATION_SUCCESS = "get/book/citation/success";
export const GET_BOOK_CITATION_ERROR = "get/book/citation/error";
